export function toManilaDateTimeInput(value) {
  if (!value) return '';
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return '';
  return new Date(date.getTime() + 8 * 60 * 60 * 1000).toISOString().slice(0, 16);
}

export function manilaDateTimeToUtc(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(value || '');
  if (!match) return new Date(NaN);
  const [, year, month, day, hour, minute] = match;
  const parts = [Number(year), Number(month), Number(day), Number(hour), Number(minute)];
  const [yearNumber, monthNumber, dayNumber, hourNumber, minuteNumber] = parts;
  const wallTime = new Date(Date.UTC(yearNumber, monthNumber - 1, dayNumber, hourNumber, minuteNumber));
  if (
    wallTime.getUTCFullYear() !== yearNumber
    || wallTime.getUTCMonth() !== monthNumber - 1
    || wallTime.getUTCDate() !== dayNumber
    || wallTime.getUTCHours() !== hourNumber
    || wallTime.getUTCMinutes() !== minuteNumber
  ) {
    return new Date(NaN);
  }
  return new Date(wallTime.getTime() - 8 * 60 * 60 * 1000);
}

export function currentManilaDateTimeInput() {
  return toManilaDateTimeInput(new Date(Date.now() + 60 * 1000));
}
